import { ListChecks } from "lucide-react";

export function RecommendationsList({ items }: { items: string[] }) {
  return (
    <section className="rounded-xl border border-border bg-card p-5 shadow-elegant">
      <header className="flex items-center gap-2 mb-3">
        <ListChecks className="size-4 text-primary" />
        <h3 className="font-display font-semibold">Próximos pasos recomendados</h3>
      </header>
      {items.length === 0 ? (
        <p className="text-sm text-muted-foreground">
          Aún no hay recomendaciones. Ejecuta el análisis IA para obtenerlas.
        </p>
      ) : (
        <ol className="space-y-2">
          {items.map((r, i) => (
            <li key={r} className="flex gap-2.5 text-sm text-foreground">
              <span className="shrink-0 size-5 rounded-full bg-primary/10 text-primary text-[11px] font-semibold inline-flex items-center justify-center tabular-nums">
                {i + 1}
              </span>
              <span className="leading-relaxed">{r}</span>
            </li>
          ))}
        </ol>
      )}
    </section>
  );
}
